import { LMS_ROLES } from "../utils/lmsRole";

const LmsRoleToggle = ({ value, onChange }) => (
  <div className="lms-role-toggle" role="radiogroup" aria-label="Registration role">
    <button
      type="button"
      className={value === LMS_ROLES.teacher ? "active" : ""}
      onClick={() => onChange(LMS_ROLES.teacher)}
      aria-pressed={value === LMS_ROLES.teacher}
    >
      Teacher
    </button>
    <button
      type="button"
      className={value === LMS_ROLES.parent ? "active" : ""}
      onClick={() => onChange(LMS_ROLES.parent)}
      aria-pressed={value === LMS_ROLES.parent}
    >
      Parent
    </button>
  </div>
);

export default LmsRoleToggle;
